export class UserInfoVM{
    public userID:number
    public userName:string
}

export class CustomerUserContacts{
           equipmentid_auto:number;
            user_auto :number;
            customer_auto:number;
            EvalA :boolean;
            EvalB:boolean;
            EvalC:boolean;
            EvalX :boolean;
            eq_undercarriage:boolean;
            modified_date:Date;
            Type :string;
}

export class Jobsite_tab
{
    public  equipmentid_auto:number;
    public  user_auto :any[];
    public  customer_auto :number;
    public  EvalA :true;
    public  EvalB :true;
    public  EvalC  :true;
    public  EvalX :true;
    public crsfAuto:number;
    public userID:number
    
  

}
export class EquipmentTab
        {
            public  equipmentid_auto:number;
            public  serialno :string;
            public  unitno :string;
        }

export class ListCL{
            public  equipmentid_auto:number;
            public  serialno :string;
    public  unitno :string;
            
    public  user_auto :number;
    public  customer_auto :number;
    public  EvalA :true;
    public  EvalB :true;
    public  EvalC  :true;
    public  EvalX :true;
}  
export class EqLevelData
{
    public  equipmentid_auto:number;
    public  user_auto :any[];
    public  customer_auto :number;
    public  EvalA :true;
    public  EvalB :true;
    public  EvalC  :true;
    public  EvalX :true;
    public crsfAuto:number;
    public siteName:string;
    public serialno:string;
    public Type:string;
    public modified_date:Date;
    
    
  

}     

export class CustomerIdAndNameDataSet
{
    public customerId:number
    public customerName:string
}

export class UserInfoVMJS
{
    public userID:number
    public userName:string
    public user_auto:number
    public crsf_auto:number
}

export class UserOverviewModelCustomerContact
{
    public  UserId:number
    public  FullName :string
    public  UserName:string
    public  Email:string
    public  Access :string
    public  Disabled:boolean
    public  TeamName:string[]
    public username:string
}
export class Customer_ContactVM
    {
        public equipmentid_auto:number
        public user_auto:number
        public customer_auto:number
        public EvalA:boolean
        public EvalB:boolean
        public EvalC:boolean
        public EvalX:boolean
        public eq_undercarriage:boolean
        public modified_date:Date
        public Type:string
        public username:string
    }

    export class JSLVM
    {
        public equipmentid_auto:number
        public user_auto:number[]
        public customer_auto:number
        public EvalA:boolean
        public EvalB:boolean
        public EvalC:boolean
        public EvalX:boolean
        public eq_undercarriage:boolean
        public modified_date:Date
        public Type:string
        public username:string
        public site_name:string
        public crsf_auto:number
        public  userid:string

    }

    export class crsfVM
    {


        public createdDate:Date
        public createdUser:string
        public modifiedDate:Date
        public  modifiedUser:string
        public  site_name :string
        public  username :string

        public  userid :string
        public  EvalA :boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  equipmentid_auto :number
        public  user_auto :number
        public  customer_auto :number
        public  crsf_auto :number
        public wty_letter:boolean
        public  IsCheckedupdateorDeleteJS:boolean
        public  service:boolean
        public  eq_health:boolean
        public  eq_undercarriage:boolean
        public  userName:string
        public Type:string
        public cust_name:string
    }

    export class crsfNewVM
    {
        public createdDate:Date
        public  createdUser:string
        public modifiedDate:Date
        public  modifiedUser :string
        public  site_name :string
        public  username :string
        public  userid :string
        public  EvalA:boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  equipmentid_auto:number
        public  user_auto :number
        public  customer_auto :number
        public  crsf_auto :number
        public  IsCheckedupdateorDeleteJS :boolean
    }

    export class EquipmentTabVM
    {
        public  equipmentid_auto:number
        public  serialno:string 
        public  unitno:string
        public  siteName:string
        public  userName:string
        public  user_auto:number
        public  customer_auto:number
        public  isCheckedForUpdateOrUpdate:boolean
        public  EvalA:boolean
        public  EvalB:boolean
        public  EvalC:boolean
        public  EvalX:boolean
        public  crsf_auto:number

    }

    export class EqLevelDataforCustomerContact
    {
        public  equipmentid_auto:number
        public  user_auto:number[] 
        public  customer_auto:number
        public  EvalA:boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  eq_undercarriage :boolean
        public  modified_date:Date
        public  Type:string
        public  site_name:string
        public  serialno:string
        public  crsf_auto:number
        public  username :string
        public  userid :string

    }

    export class EqLevelDataforUserContact
    {
        public  equipmentid_auto:number[]
        public  user_auto:number
        public  customer_auto:number
        public  EvalA:boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  eq_undercarriage :boolean
        public  modified_date:Date
        public  Type:string
        public  site_name:string
        public  serialno:string
        public  crsf_auto:number
        public  username :string
        public  userid :string

    }


    export class EquipmentTabforCuatomerContact
    {
        public  equipmentid_auto:number
        public  serialno:string
        public  unitno:string
        public siteName :string
        public userName :string
        public  user_auto:number
        public  customer_auto:number
        public  isCheckedForUpdateOrUpdate:boolean
        public  EvalA :boolean
        public  EvalB:boolean
        public  EvalC:boolean
        public  EvalX:boolean
        public  crsf_auto:number
        public wty_letter:boolean
        public service:boolean
        public eq_health:boolean
        public eq_undercarriage:boolean
        public cust_name:string
        public  Type:string
        public UnitNo:string
    }

    export class UpdateCLRow
    {
        public  equipmentid_auto:number
        public  user_auto:number
        public  customer_auto:number
        public  EvalA:boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  eq_undercarriage :boolean
        public  modified_date :Date
        // public string Type { get; set; }
        public  eq_health :boolean
        public  username:string
        public  crsf_auto:number
        public  wty_letter :boolean
        public  service:boolean
      
    }

    export class CustomerdataForExcel
    {
        public  user_auto:number
        public  userName :string
        public  email:string
        public  phone:string
        public  EvalA :boolean
        public  EvalB :boolean
        public  EvalC :boolean
        public  EvalX :boolean
        public  sendemail :boolean
        public  Pdf :boolean
        public  Contact :boolean
        public  type:string
        public  jobsite:string

    }

    export class JSLVM_USER
    {
        public equipmentid_auto:number
        public user_auto:number
        public customer_auto:number
        public EvalA:boolean
        public EvalB:boolean
        public EvalC:boolean
        public EvalX:boolean
        public eq_undercarriage:boolean
        public modified_date:Date
        public Type:string
        public username:string
        public site_name:string
        public crsf_auto:number[]
        public  userid:string

    }


    export class WarrantyTypeVM{
        public ID :number;
        public Type:string
        public Days:number;
        public Hours:number;
        public NoOfCycles:number;
        public Status:number;
    }

    
    export class GETImplementWarrantyVM
    {
        public  ID:number;
        public  ImplementId :number;
        public  WarrantyId :number;
        public  warrantyTypeName:string
        public  startDate:Date
        public  startSMU :number;
        public  startCucleNO :number;
        public  modifiedUserID:number;   
        public  modifiedUserName:string
        public  modifiesDate:Date
        public  isExpired :boolean;
        public WarrantyTypeIntialHours:number
        public WarrantyTypeIntialDays:number
        public BucketCMU:number;

        

    }